var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelloImg1649933868113(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 331,
    viewBox: "0 0 406 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.34 0H4.65953C2.08614 0 0 2.09461 0 4.67845V260.706C0 263.29 2.08614 265.385 4.65953 265.385H401.34C403.914 265.385 406 263.29 406 260.706V4.67845C406 2.09461 403.914 0 401.34 0Z",
    fill: "#11111A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34 0H4.65953C2.08614 0 0 2.09461 0 4.67845V260.706C0 263.29 2.08614 265.385 4.65953 265.385H401.34C403.914 265.385 406 263.29 406 260.706V4.67845C406 2.09461 403.914 0 401.34 0Z",
    fill: "#11111A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240.316H406V260.745C406 261.986 405.509 263.176 404.635 264.053C403.761 264.931 402.576 265.424 401.34 265.424H4.65953C3.42374 265.424 2.23857 264.931 1.36474 264.053C0.490913 263.176 0 261.986 0 260.745L0 240.316Z",
    fill: "#262636"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 10,
    width: 396,
    height: 229
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.719 10.9164H5.43611V238.967H400.719V10.9164Z",
    fill: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.719 10.9164H5.43611V238.967H400.719V10.9164Z",
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.006,
    y: 19.2212,
    width: 301.01,
    height: 211.603,
    rx: 4.05281,
    fill: "#36393F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 48.604C277.217 47.4849 278.124 46.5776 279.243 46.5776H293.428C294.547 46.5776 295.454 47.4849 295.454 48.604V54.6833C295.454 55.8024 294.547 56.7097 293.428 56.7097H279.243C278.124 56.7097 277.217 55.8024 277.217 54.6833V48.604Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.507 48.604C299.507 47.4849 300.415 46.5776 301.534 46.5776H368.405C369.524 46.5776 370.431 47.4849 370.431 48.604V54.6833C370.431 55.8024 369.524 56.7097 368.405 56.7097H301.534C300.415 56.7097 299.507 55.8024 299.507 54.6833V48.604Z",
    fill: "#6ADBC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.243 66.8417C279.243 65.7226 280.15 64.8153 281.27 64.8153H374.484C375.603 64.8153 376.511 65.7226 376.511 66.8417V72.9209C376.511 74.0401 375.603 74.9473 374.484 74.9473H281.27C280.15 74.9473 279.243 74.0401 279.243 72.9209V66.8417Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.564 66.8418C380.564 65.7227 381.471 64.8154 382.59 64.8154H475.805C476.924 64.8154 477.831 65.7227 477.831 66.8418V72.9211C477.831 74.0402 476.924 74.9475 475.805 74.9475H382.59C381.471 74.9475 380.564 74.0402 380.564 72.9211V66.8418Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 85.0794C277.217 83.9602 278.124 83.053 279.243 83.053H346.115C347.234 83.053 348.141 83.9602 348.141 85.0794V91.1586C348.141 92.2778 347.234 93.185 346.115 93.185H279.243C278.124 93.185 277.217 92.2778 277.217 91.1586V85.0794Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.194 85.0794C352.194 83.9602 353.101 83.053 354.22 83.053H368.405C369.524 83.053 370.431 83.9602 370.431 85.0794V91.1586C370.431 92.2778 369.524 93.185 368.405 93.185H354.22C353.101 93.185 352.194 92.2778 352.194 91.1586V85.0794Z",
    fill: "#648AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 103.317C277.217 102.198 278.124 101.291 279.243 101.291H333.956C335.075 101.291 335.983 102.198 335.983 103.317V109.396C335.983 110.515 335.075 111.423 333.956 111.423H279.243C278.124 111.423 277.217 110.515 277.217 109.396V103.317Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.035 103.317C340.035 102.198 340.943 101.291 342.062 101.291H392.722C393.841 101.291 394.748 102.198 394.748 103.317V109.396C394.748 110.515 393.841 111.423 392.722 111.423H342.062C340.943 111.423 340.035 110.515 340.035 109.396V103.317Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 121.555C277.217 120.436 278.124 119.528 279.243 119.528H356.247C357.366 119.528 358.273 120.436 358.273 121.555V127.634C358.273 128.753 357.366 129.66 356.247 129.66H279.243C278.124 129.66 277.217 128.753 277.217 127.634V121.555Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.326 121.555C362.326 120.435 363.233 119.528 364.352 119.528H441.356C442.475 119.528 443.382 120.435 443.382 121.555V127.634C443.382 128.753 442.475 129.66 441.356 129.66H364.352C363.233 129.66 362.326 128.753 362.326 127.634V121.555Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 139.792C277.217 138.673 278.124 137.766 279.243 137.766H346.115C347.234 137.766 348.141 138.673 348.141 139.792V145.872C348.141 146.991 347.234 147.898 346.115 147.898H279.243C278.124 147.898 277.217 146.991 277.217 145.872V139.792Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.194 139.792C352.194 138.673 353.101 137.766 354.22 137.766H368.405C369.524 137.766 370.431 138.673 370.431 139.792V145.872C370.431 146.991 369.524 147.898 368.405 147.898H354.22C353.101 147.898 352.194 146.991 352.194 145.872V139.792Z",
    fill: "#6ADBC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 158.03C277.217 156.911 278.124 156.004 279.243 156.004H368.405C369.524 156.004 370.432 156.911 370.432 158.03V164.109C370.432 165.228 369.524 166.136 368.405 166.136H279.243C278.124 166.136 277.217 165.228 277.217 164.109V158.03Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.484 158.03C374.484 156.911 375.392 156.004 376.511 156.004H437.303C438.422 156.004 439.329 156.911 439.329 158.03V164.109C439.329 165.228 438.422 166.136 437.303 166.136H376.511C375.392 166.136 374.484 165.228 374.484 164.109V158.03Z",
    fill: "#E05FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 176.268C277.217 175.148 278.124 174.241 279.243 174.241H293.428C294.547 174.241 295.454 175.148 295.454 176.268V182.347C295.454 183.466 294.547 184.373 293.428 184.373H279.243C278.124 184.373 277.217 183.466 277.217 182.347V176.268Z",
    fill: "#648AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.507 176.268C299.507 175.148 300.415 174.241 301.534 174.241H396.775C397.894 174.241 398.801 175.148 398.801 176.268V182.347C398.801 183.466 397.894 184.373 396.775 184.373H301.534C300.415 184.373 299.507 183.466 299.507 182.347V176.268Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.026 203.765L280.807 208.575L276.026 213.386L277.498 214.864L283.761 208.575L277.498 202.287L276.026 203.765Z",
    fill: "#2DDFB4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7253,
    y: 18.9143,
    width: 234.959,
    height: 212.282,
    rx: 4.06582,
    fill: "#292841"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 55,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 63.3733,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 63.3733,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.677 68.3875L109.593 70.8985C109.508 71.0967 109.385 71.2758 109.23 71.4253C109.075 71.5747 108.891 71.6914 108.691 71.7685C108.49 71.8455 108.276 71.8813 108.061 71.8739C107.846 71.8664 107.635 71.8157 107.44 71.7248L103.388 69.8734L105.406 66.6791L107.876 68.0617L108.24 66.981C109.514 67.4896 110.194 67.9346 110.677 68.3875Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.968 67.1718C107.599 67.4419 107.749 67.7836 108.184 68.6418L106.435 68.4431L105.968 67.1718Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2918 53.56C97.9676 53.6615 97.6939 53.883 97.5264 54.1796C97.3588 54.4762 97.31 54.8257 97.3896 55.1572L99.012 61.8081L101.916 61.2042L99.9617 54.4659C99.9127 54.2954 99.8304 54.1364 99.7196 53.9982C99.6088 53.86 99.4716 53.7454 99.3161 53.6611C99.1606 53.5767 98.99 53.5244 98.8141 53.507C98.6382 53.4897 98.4607 53.5077 98.2918 53.56Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9063 60.2507L101.054 60.203L99.8351 56.1982C99.8182 56.1406 99.7897 56.0872 99.7513 56.0411C99.713 55.9951 99.6656 55.9575 99.6122 55.9307C99.5587 55.9038 99.5003 55.8883 99.4406 55.8851C99.3809 55.882 99.3212 55.8911 99.2653 55.9121C99.167 55.9498 99.0861 56.0225 99.0379 56.1163C98.9897 56.2101 98.9777 56.3185 99.0041 56.4207L99.9063 60.2507Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.011 53.5282C105.336 53.6264 105.612 53.8454 105.783 54.1406C105.953 54.4357 106.006 54.785 105.929 55.1175L104.378 61.7763L101.465 61.2121L103.349 54.45C103.396 54.2789 103.477 54.1191 103.587 53.9798C103.696 53.8405 103.832 53.7245 103.987 53.6387C104.142 53.5529 104.312 53.4989 104.488 53.4799C104.664 53.461 104.841 53.4774 105.011 53.5282Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.911 60.2348L102.771 60.1951L103.942 56.1744C103.959 56.1168 103.988 56.0634 104.026 56.0176C104.065 55.9718 104.112 55.9346 104.166 55.9084C104.22 55.8822 104.278 55.8676 104.338 55.8655C104.397 55.8634 104.457 55.8739 104.512 55.8962C104.61 55.9323 104.692 56.0031 104.741 56.0953C104.791 56.1876 104.805 56.2948 104.781 56.3968L103.911 60.2348Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.163 69.9291L106.689 71.4389L106.625 71.6296L106.04 73.4731H95.15C95.0471 73.0678 95.1737 72.9883 95.4507 72.5354C95.7277 72.0825 95.5853 72.2017 95.6248 71.1051C95.6565 70.3343 95.9335 69.6192 96.9227 68.7292C97.2235 68.467 97.2947 68.3637 97.6033 68.0777L97.6983 67.9902L97.7458 67.9426L97.8091 67.8949L105.248 66.7189L106.744 69.2219L107.163 69.9291Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.689 71.4389C106.641 72.1619 106.578 72.8453 106.499 73.4731H98.4976C98.5055 73.1473 98.5134 72.742 98.5292 72.2494C98.5279 72.1963 98.5306 72.1431 98.5372 72.0904V71.4786C98.4818 70.0244 98.0702 69.0312 96.9227 68.7292C97.1364 68.5147 97.358 68.3001 97.6033 68.0777L97.6983 67.9902L97.8091 67.8949L105.248 66.7189C105.834 66.9334 106.222 67.0844 106.665 67.5373C106.712 68.1094 106.736 68.6736 106.744 69.2219C106.752 69.9927 106.728 70.7316 106.689 71.4389Z",
    fill: "#1F3A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.975 63.5738L97.3406 63.9205C96.2042 63.9662 95.3198 64.9281 95.3652 66.0692L95.3654 66.0723C95.4108 67.2133 96.3689 68.1013 97.5053 68.0557L106.139 67.7089C107.276 67.6633 108.16 66.7013 108.115 65.5603L108.115 65.5571C108.069 64.4161 107.111 63.5281 105.975 63.5738Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.524 59.7304L97.1345 60.0834C95.9336 60.134 95.0009 61.1524 95.0512 62.3582L95.0542 62.4304C95.1045 63.6362 96.1189 64.5727 97.3198 64.5222L105.709 64.1691C106.91 64.1186 107.843 63.1002 107.792 61.8944L107.789 61.8221C107.739 60.6163 106.725 59.6798 105.524 59.7304Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.111 67.6405C107.219 67.5929 108.129 66.6949 108.129 65.5825C108.133 65.178 108.017 64.7813 107.798 64.4422C107.578 64.103 107.264 63.8363 106.894 63.6754C107.173 63.4623 107.396 63.1849 107.544 62.8667C107.693 62.5485 107.763 62.199 107.749 61.8478V61.7763C107.737 61.4893 107.668 61.2075 107.548 60.947C107.427 60.6865 107.256 60.4526 107.045 60.2585C106.834 60.0643 106.587 59.9139 106.318 59.8158C106.049 59.7176 105.764 59.6737 105.478 59.6865L97.9911 60.0043C97.3184 61.2996 97.4134 62.6901 97.912 63.6913C97.9847 63.8429 98.0257 64.0078 98.0325 64.1759C98.0393 64.344 98.0118 64.5117 97.9515 64.6687C97.2314 66.5917 98.181 67.9822 98.181 67.9822L106.111 67.6405Z",
    fill: "#E05FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.065 63.7452C100.256 63.6203 100.266 63.2987 100.089 63.027C99.912 62.7552 99.6143 62.6362 99.4241 62.7612C99.2339 62.8861 99.2233 63.2077 99.4004 63.4795C99.5775 63.7512 99.8752 63.8702 100.065 63.7452Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.815 63.1518C103.898 62.8559 103.8 62.5702 103.598 62.5135C103.396 62.4569 103.166 62.6508 103.083 62.9467C103.001 63.2426 103.098 63.5283 103.3 63.585C103.502 63.6416 103.733 63.4477 103.815 63.1518Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.896 64.7005C101.418 65.5905 102.186 65.7971 102.7 64.6449C102.706 64.6346 102.709 64.6228 102.709 64.6108C102.708 64.5989 102.705 64.5872 102.698 64.5773C102.692 64.5673 102.682 64.5594 102.671 64.5545C102.66 64.5496 102.648 64.5479 102.637 64.5496L100.951 64.5972C100.94 64.5986 100.929 64.6026 100.919 64.6091C100.91 64.6156 100.902 64.6242 100.896 64.6344C100.891 64.6445 100.888 64.6558 100.888 64.6674C100.888 64.6789 100.89 64.6903 100.896 64.7005Z",
    fill: "#751B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.948 64.5734L100.951 64.5972C100.94 64.5985 100.929 64.6026 100.919 64.6091C100.91 64.6155 100.902 64.6242 100.896 64.6343C100.891 64.6445 100.888 64.6558 100.888 64.6673C100.888 64.6788 100.89 64.6902 100.896 64.7005C101.347 65.4633 101.972 65.7255 102.47 65.0581C102.347 64.8491 102.165 64.6808 101.948 64.5734Z",
    fill: "#9C2455"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 55.3627,
    width: 19.1478,
    height: 8.01063,
    rx: 2.03291,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.606,
    y: 58.567,
    width: 19.1478,
    height: 4.80638,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 67.0084C115.863 65.8856 116.773 64.9755 117.896 64.9755H190.421C191.544 64.9755 192.454 65.8856 192.454 67.0084V85.3723C192.454 86.4951 191.544 87.4052 190.421 87.4052H117.896C116.773 87.4052 115.863 86.4951 115.863 85.3723V67.0084Z",
    fill: "#1C1B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82 73.4168C131.82 72.2941 132.73 71.3839 133.852 71.3839H187.23C188.353 71.3839 189.263 72.2941 189.263 73.4168V78.9638C189.263 80.0865 188.353 80.9967 187.23 80.9967H133.852C132.73 80.9967 131.82 80.0865 131.82 78.9638V73.4168Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.442 80.5961C122.287 80.5961 121.448 79.6697 121.448 78.3932V74.9887C121.448 73.3901 122.562 72.1849 124.041 72.1849C125.519 72.1849 126.634 73.3901 126.634 74.9887V77.7924H125.836V74.9887C125.836 73.8279 125.081 72.986 124.041 72.986C123.001 72.986 122.246 73.8279 122.246 74.9887V78.3932C122.246 79.0913 122.616 79.795 123.442 79.795C124.269 79.795 124.639 79.0913 124.639 78.3932V75.3892C124.639 75.1481 124.581 74.5881 124.041 74.5881C123.501 74.5881 123.442 75.1481 123.442 75.3892V78.1929H122.645V75.3892C122.645 74.4307 123.206 73.7871 124.041 73.7871C124.876 73.7871 125.437 74.4307 125.437 75.3892V78.3932C125.437 79.6697 124.598 80.5961 123.442 80.5961Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 93,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 101.824,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 101.824,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#FFB869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.408 104.44C98.3391 107.691 102.085 109.944 105.09 107.819C108.095 105.694 105.111 101.338 105.111 101.338C105.111 101.338 106.741 97.2159 102.656 96.2385C98.5719 95.2611 97.5561 97.0459 97.408 104.44Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.461 102.061C103.005 102.061 102.635 101.566 102.635 100.956C102.635 100.345 103.005 99.8507 103.461 99.8507C103.916 99.8507 104.286 100.345 104.286 100.956C104.286 101.566 103.916 102.061 103.461 102.061Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.814 101.795C103.698 101.787 103.616 101.6 103.631 101.377C103.646 101.155 103.753 100.981 103.869 100.989C103.986 100.997 104.068 101.184 104.053 101.406C104.038 101.629 103.931 101.803 103.814 101.795Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.413 98.8945C104.358 98.7295 104.253 98.5859 104.113 98.4842C103.972 98.3825 103.803 98.3278 103.63 98.3278C103.456 98.3278 103.288 98.3825 103.147 98.4842C103.007 98.5859 102.902 98.7295 102.847 98.8945H104.413Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.328 103.59C103.524 103.803 102.656 103.612 101.937 102.826C101.843 102.718 101.711 102.651 101.569 102.639C101.427 102.627 101.285 102.671 101.175 102.762C101.055 102.844 100.971 102.97 100.944 103.114C100.916 103.257 100.946 103.405 101.027 103.527C102.127 105.333 103.841 105.609 104.9 104.589C104.972 104.524 105.026 104.44 105.056 104.347C105.086 104.253 105.09 104.154 105.069 104.058C105.054 103.977 105.023 103.899 104.977 103.831C104.931 103.762 104.871 103.704 104.801 103.66C104.732 103.616 104.653 103.587 104.572 103.575C104.491 103.563 104.408 103.568 104.328 103.59Z",
    fill: "#590942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.714 103.675C103.922 103.677 104.129 103.649 104.328 103.59H104.519V104.122C104.519 104.122 104.201 104.355 103.016 104.228V103.93L100.942 103.229C100.943 103.142 100.964 103.056 101.005 102.978C101.045 102.9 101.104 102.834 101.175 102.783C101.175 102.777 101.177 102.772 101.181 102.768C101.185 102.764 101.19 102.762 101.196 102.762C101.283 102.702 101.387 102.672 101.492 102.677C101.514 102.656 101.556 102.677 101.577 102.677H101.767C101.789 102.698 101.81 102.698 101.81 102.719C101.81 102.741 101.852 102.719 101.852 102.741L101.937 102.804C102.062 102.948 102.204 103.077 102.36 103.187L102.656 103.378C102.794 103.463 102.944 103.528 103.101 103.569C103.298 103.637 103.506 103.673 103.714 103.675Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.175 102.762C101.175 102.756 101.177 102.751 101.181 102.747C101.185 102.743 101.19 102.741 101.196 102.741C101.283 102.681 101.387 102.651 101.492 102.656C101.514 102.634 101.556 102.656 101.577 102.656H101.767C101.789 102.677 101.81 102.677 101.81 102.698C101.81 102.719 101.852 102.698 101.852 102.719L101.937 102.783C102.003 102.871 102.082 102.95 102.17 103.017L101.577 103.378L100.942 103.166C100.949 103.085 100.974 103.008 101.014 102.938C101.054 102.868 101.109 102.808 101.175 102.762Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2757 97.7259C99.0375 96.026 100.371 95.686 102.656 96.2385C103.117 96.3417 103.559 96.5136 103.968 96.7484C104.095 97.4284 103.058 97.6409 101.133 97.0247C101.767 98.1721 100.455 100.212 98.2757 97.7259Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.942 96.1748L101.048 94.7724C101.057 94.6444 101.039 94.5158 100.995 94.3955C100.95 94.2751 100.88 94.1659 100.79 94.0751C100.7 93.9843 100.591 93.9142 100.471 93.8695C100.351 93.8248 100.223 93.8067 100.096 93.8162C99.952 93.8243 99.8125 93.8674 99.6891 93.9416C99.5657 94.0159 99.4621 94.1191 99.3872 94.2423C99.3123 94.3656 99.2683 94.5054 99.259 94.6495C99.2497 94.7936 99.2753 94.9379 99.3338 95.0698L99.9687 96.5148L100.942 96.1748Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4399 103.676L96.0747 103.909L97.408 103.038V104.122L98.5084 104.993C98.7396 105.184 98.93 105.42 99.0682 105.686C99.2064 105.953 99.2895 106.244 99.3126 106.544L99.355 107.415C100.963 108.754 103.164 109.179 105.09 107.819C105.403 107.609 105.682 107.351 105.915 107.054L106.571 107.288C106.571 107.288 105.238 112.919 103.016 113.939C100.794 114.959 99.2491 113.939 99.2491 113.939C96.9212 105.992 97.5985 104.504 91.8422 106.799L91.5671 105.184L95.4399 103.676Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.053 101.147L95.8631 97.2159L95.4822 97.7047L98.7201 103.761L100.053 101.147Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5296 100.254L96.8789 99.0858L98.1487 101.381L97.9159 100.488L98.5296 100.254Z",
    fill: "#3366E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 93.8137,
    width: 24.3949,
    height: 10.1645,
    rx: 2.03291,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.291,
    y: 97.8795,
    width: 24.3949,
    height: 6.09873,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 105.459C115.863 104.337 116.773 103.427 117.896 103.427H190.421C191.544 103.427 192.454 104.337 192.454 105.459V109.404C192.454 110.527 191.544 111.437 190.421 111.437H115.863V105.459Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 111.437H154.159V117.415C154.159 118.538 153.248 119.448 152.126 119.448H117.896C116.773 119.448 115.863 118.538 115.863 117.415V111.437Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 125,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 133.867,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 133.867,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#FF82A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.014 127.73L105.991 127.799L105.921 127.966L105.897 128.034L105.843 128.156C104.649 130.942 102.361 132.996 100.845 134.425C99.2757 135.897 97.5094 137.142 95.5978 138.126C93.7149 139.034 92.8647 138.22 93.0761 136.676L93.2653 135.901L94.1964 131.993L94.2361 131.803C94.8664 129.257 95.836 127.794 98.9852 127.002L103.777 125.818L103.793 125.811C105.466 125.404 106.63 125.968 106.014 127.73Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.523 125.833C104.003 126.088 101.156 127.926 98.3309 130.623C95.5061 133.321 93.3466 136.298 93.1512 137.758C93.4173 138.537 94.2347 138.778 95.599 138.126C97.5105 137.143 99.2765 135.897 100.846 134.425C102.362 132.997 104.649 130.943 105.843 128.157L105.898 128.036L105.921 127.967L105.991 127.8L106.014 127.732C106.38 126.699 106.136 126.081 105.523 125.833Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.006 133.42C103.747 130.808 105.566 128.266 105.07 127.741C104.575 127.217 101.951 128.908 99.2102 131.519C96.4696 134.131 94.6499 136.673 95.1458 137.197C95.6417 137.722 98.2654 136.031 101.006 133.42Z",
    fill: "#6B3143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.436 137.958L99.7102 138.486C99.535 138.603 99.388 138.758 99.28 138.939C99.1719 139.12 99.1056 139.323 99.0858 139.533L98.9633 140.484L97.6848 141.663C97.4173 141.927 97.2594 142.282 97.2431 142.658L97.25 143.564C97.25 143.564 104.23 147.294 107.987 146.62C111.743 145.946 109.464 139.486 109.464 139.486C109.43 139.422 109.38 139.37 109.319 139.333C109.258 139.296 109.188 139.277 109.116 139.278L108.001 139.201L107.526 138.032C107.482 137.924 107.412 137.828 107.323 137.753C107.234 137.678 107.128 137.626 107.013 137.602L103.725 136.908L100.436 137.958Z",
    fill: "#EF6270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.591 139.905C99.5906 139.715 99.6587 139.738 99.9438 139.275C100.107 138.989 100.345 138.754 100.633 138.595L100.591 139.905Z",
    fill: "#BD3C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 130.614C102.009 130.483 101 131.208 99.882 132.251C98.7637 133.295 97.9576 134.241 98.078 134.372C99.4188 136.424 100.312 138.373 100.587 139.907L106.046 140.975C105.756 136.111 103.492 132.788 102.13 130.614Z",
    fill: "#FFB685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2 134.938C104.154 134.765 104.022 134.651 103.904 134.682C103.786 134.714 103.727 134.879 103.773 135.052C103.819 135.225 103.951 135.339 104.069 135.307C104.187 135.276 104.246 135.11 104.2 134.938Z",
    fill: "#543247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.408 135.958C102.494 135.834 102.432 135.643 102.27 135.53C102.109 135.418 101.908 135.427 101.823 135.551C101.737 135.675 101.799 135.866 101.961 135.979C102.122 136.091 102.323 136.082 102.408 135.958Z",
    fill: "#543247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.532 137.644C103.989 137.419 104.409 137.193 104.606 137.248C104.802 137.303 104.716 137.668 104.499 138.077C104.283 138.487 104.345 138.305 103.846 138.172C103.346 138.039 103.181 137.817 103.532 137.644Z",
    fill: "#C74153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.722 137.569L103.371 137.818C103.385 137.963 103.588 138.109 103.846 138.172C104.103 138.234 104.399 138.259 104.499 138.077L104.592 137.88C104.464 137.772 104.11 137.511 103.722 137.569Z",
    fill: "#A82C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.415 137.246C104.11 137.352 103.814 137.485 103.532 137.644C103.333 137.741 103.348 137.848 103.438 137.955L104.489 137.475C104.55 137.445 104.475 137.331 104.415 137.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 135.816C105.748 135.793 105.733 135.762 105.741 135.74C105.723 135.585 105.658 135.44 105.554 135.325C105.451 135.21 105.314 135.13 105.163 135.096C105.199 135.129 105.228 135.169 105.247 135.215C105.265 135.261 105.273 135.31 105.27 135.359C105.266 135.408 105.252 135.456 105.227 135.499C105.203 135.542 105.169 135.578 105.128 135.606C104.981 135.69 104.817 135.738 104.648 135.747C104.429 135.772 104.217 135.845 104.029 135.96C103.84 136.076 103.679 136.232 103.557 136.417C102.783 136.381 102.513 136.874 101.964 137.144C101.816 137.221 101.657 137.274 101.493 137.3C100.953 137.395 100.864 137.174 100.851 136.877C100.255 137.36 100.628 138.048 101.09 138.218C101.362 138.35 101.726 138.284 102.109 137.982C103.055 138.217 103.39 138.09 103.937 137.196C104.838 137.416 105.418 137.054 105.464 136.217C105.539 136.179 105.605 136.122 105.653 136.052C105.701 135.981 105.731 135.9 105.74 135.816Z",
    fill: "#6B3143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.937 137.196C104.838 137.416 105.418 137.054 105.464 136.217C105.54 136.179 105.605 136.122 105.653 136.052C105.701 135.982 105.731 135.901 105.741 135.816C105.748 135.793 105.733 135.763 105.741 135.74C105.726 135.661 105.701 135.584 105.667 135.511C105.678 135.637 105.641 135.763 105.565 135.863C105.488 135.964 105.377 136.033 105.253 136.056C104.982 136.663 104.434 136.781 103.806 136.655C103.806 136.655 103.098 137.647 102.122 137.427C101.433 137.992 100.698 137.919 100.544 137.369C100.529 137.552 100.575 137.733 100.674 137.887C100.772 138.04 100.919 138.157 101.09 138.218C101.362 138.35 101.727 138.284 102.109 137.982C103.055 138.217 103.39 138.09 103.937 137.196Z",
    fill: "#5E2737"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 125.856,
    width: 19.1478,
    height: 8.01063,
    rx: 2.03291,
    fill: "#FFA78B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.606,
    y: 129.061,
    width: 19.1478,
    height: 4.80638,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 137.502C115.863 136.379 116.773 135.469 117.896 135.469H190.421C191.544 135.469 192.454 136.379 192.454 137.502V141.447C192.454 142.569 191.544 143.48 190.421 143.48H117.896C116.773 143.48 115.863 142.569 115.863 141.447V137.502Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 149,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 157.899,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 157.899,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.677 162.913L109.593 165.424C109.508 165.622 109.385 165.801 109.23 165.951C109.075 166.1 108.891 166.217 108.691 166.294C108.49 166.371 108.276 166.407 108.061 166.399C107.846 166.392 107.635 166.341 107.44 166.25L103.388 164.399L105.406 161.205L107.876 162.587L108.24 161.507C109.514 162.015 110.194 162.46 110.677 162.913Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.968 161.697C107.599 161.967 107.749 162.309 108.184 163.167L106.435 162.969L105.968 161.697Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2918 148.086C97.9676 148.187 97.6939 148.409 97.5264 148.705C97.3588 149.002 97.31 149.351 97.3896 149.683L99.012 156.334L101.916 155.73L99.9617 148.991C99.9127 148.821 99.8304 148.662 99.7196 148.524C99.6088 148.386 99.4716 148.271 99.3161 148.187C99.1606 148.102 98.99 148.05 98.8141 148.033C98.6382 148.015 98.4607 148.033 98.2918 148.086Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9063 154.776L101.054 154.728L99.8351 150.724C99.8182 150.666 99.7897 150.613 99.7513 150.567C99.713 150.52 99.6656 150.483 99.6122 150.456C99.5587 150.429 99.5003 150.414 99.4406 150.411C99.3809 150.407 99.3212 150.417 99.2653 150.438C99.167 150.475 99.0861 150.548 99.0379 150.642C98.9897 150.736 98.9777 150.844 99.0041 150.946L99.9063 154.776Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.011 148.054C105.336 148.152 105.612 148.371 105.783 148.666C105.953 148.961 106.006 149.311 105.929 149.643L104.378 156.302L101.465 155.738L103.349 148.975C103.396 148.804 103.477 148.645 103.587 148.505C103.696 148.366 103.832 148.25 103.987 148.164C104.142 148.078 104.312 148.024 104.488 148.005C104.664 147.986 104.841 148.003 105.011 148.054Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.911 154.76L102.771 154.72L103.942 150.7C103.959 150.642 103.988 150.589 104.026 150.543C104.065 150.497 104.112 150.46 104.166 150.434C104.22 150.408 104.278 150.393 104.338 150.391C104.397 150.389 104.457 150.399 104.512 150.422C104.61 150.458 104.692 150.529 104.741 150.621C104.791 150.713 104.805 150.82 104.781 150.922L103.911 154.76Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.163 164.454L106.689 165.964L106.625 166.155L106.04 167.998H95.15C95.0471 167.593 95.1737 167.514 95.4507 167.061C95.7277 166.608 95.5853 166.727 95.6248 165.631C95.6565 164.86 95.9335 164.145 96.9227 163.255C97.2235 162.992 97.2947 162.889 97.6033 162.603L97.6983 162.516L97.7458 162.468L97.8091 162.42L105.248 161.244L106.744 163.747L107.163 164.454Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.689 165.964C106.641 166.687 106.578 167.371 106.499 167.998H98.4976C98.5055 167.673 98.5134 167.267 98.5292 166.775C98.5279 166.722 98.5306 166.669 98.5372 166.616V166.004C98.4818 164.55 98.0702 163.557 96.9227 163.255C97.1364 163.04 97.358 162.826 97.6033 162.603L97.6983 162.516L97.8091 162.42L105.248 161.244C105.834 161.459 106.222 161.61 106.665 162.063C106.712 162.635 106.736 163.199 106.744 163.747C106.752 164.518 106.728 165.257 106.689 165.964Z",
    fill: "#1F3A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.975 158.099L97.3406 158.446C96.2042 158.492 95.3198 159.454 95.3652 160.595L95.3654 160.598C95.4108 161.739 96.3689 162.627 97.5053 162.581L106.139 162.234C107.276 162.189 108.16 161.227 108.115 160.086L108.115 160.083C108.069 158.941 107.111 158.054 105.975 158.099Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.524 154.256L97.1345 154.609C95.9336 154.659 95.0009 155.678 95.0512 156.884L95.0542 156.956C95.1045 158.162 96.1189 159.098 97.3198 159.048L105.709 158.695C106.91 158.644 107.843 157.626 107.792 156.42L107.789 156.348C107.739 155.142 106.725 154.205 105.524 154.256Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.111 162.166C107.219 162.118 108.129 161.22 108.129 160.108C108.133 159.703 108.017 159.307 107.798 158.968C107.578 158.628 107.264 158.362 106.894 158.201C107.173 157.988 107.396 157.71 107.544 157.392C107.693 157.074 107.763 156.725 107.749 156.373V156.302C107.737 156.015 107.668 155.733 107.548 155.473C107.427 155.212 107.256 154.978 107.045 154.784C106.834 154.59 106.587 154.439 106.318 154.341C106.049 154.243 105.764 154.199 105.478 154.212L97.9911 154.53C97.3184 155.825 97.4134 157.216 97.912 158.217C97.9847 158.368 98.0257 158.533 98.0325 158.701C98.0393 158.87 98.0118 159.037 97.9515 159.194C97.2314 161.117 98.181 162.508 98.181 162.508L106.111 162.166Z",
    fill: "#E05FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.065 158.271C100.256 158.146 100.266 157.824 100.089 157.552C99.912 157.281 99.6143 157.162 99.4241 157.287C99.2339 157.412 99.2233 157.733 99.4004 158.005C99.5775 158.277 99.8752 158.396 100.065 158.271Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.815 157.677C103.898 157.381 103.8 157.096 103.598 157.039C103.396 156.982 103.166 157.176 103.083 157.472C103.001 157.768 103.098 158.054 103.3 158.11C103.502 158.167 103.733 157.973 103.815 157.677Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.896 159.226C101.418 160.116 102.186 160.323 102.7 159.17C102.706 159.16 102.709 159.148 102.709 159.136C102.708 159.124 102.705 159.113 102.698 159.103C102.692 159.093 102.682 159.085 102.671 159.08C102.66 159.075 102.648 159.073 102.637 159.075L100.951 159.123C100.94 159.124 100.929 159.128 100.919 159.134C100.91 159.141 100.902 159.15 100.896 159.16C100.891 159.17 100.888 159.181 100.888 159.193C100.888 159.204 100.89 159.216 100.896 159.226Z",
    fill: "#751B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.948 159.099L100.951 159.123C100.94 159.124 100.929 159.128 100.919 159.135C100.91 159.141 100.902 159.15 100.896 159.16C100.891 159.17 100.888 159.181 100.888 159.193C100.888 159.204 100.89 159.216 100.896 159.226C101.347 159.989 101.972 160.251 102.47 159.584C102.347 159.375 102.165 159.206 101.948 159.099Z",
    fill: "#9C2455"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 149.888,
    width: 19.1478,
    height: 8.01063,
    rx: 2.03291,
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.606,
    y: 153.092,
    width: 19.1478,
    height: 4.80638,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 161.534C115.863 160.411 116.773 159.501 117.896 159.501H190.421C191.544 159.501 192.454 160.411 192.454 161.534V167.511H115.863V161.534Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 167.512H192.454V173.489C192.454 174.612 191.544 175.522 190.421 175.522H117.896C116.773 175.522 115.863 174.612 115.863 173.489V167.512Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 181,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 189.941,
    rx: 7.97824,
    ry: 8.01064,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 189.941,
    rx: 7.97824,
    ry: 8.01064,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.422 200.688C110.27 200.313 110.02 199.986 109.697 199.743C109.375 199.5 108.992 199.349 108.591 199.307L107.753 199.218C106.552 194.872 107.161 193.884 103.61 192.91L100.736 192.81C100.736 192.81 97.8156 192.861 96.7406 194.304L98.2402 199.244C98.2402 199.244 97.6238 202.524 97.9025 204.186L101.646 203.699L103.267 208.966C109.384 208.052 112.235 205.206 112.235 205.206L110.422 200.688Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4256 193.198C101.499 197.026 105.18 199.64 104.563 193.6L97.4256 193.198Z",
    fill: "#B8C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4253 193.649C102.972 195.32 103.893 195.95 103.662 193.94L99.4253 193.649Z",
    fill: "#5697B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.081 196.46C106.65 194.633 106.326 193.846 104.508 193.187C104.997 194.335 105.209 196.704 105.209 196.704L107.081 196.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.027 187.632L100.898 186.622C100.854 186.292 100.707 185.985 100.478 185.745C100.249 185.505 99.9503 185.344 99.6242 185.286C99.2659 185.224 98.897 185.29 98.5821 185.473C98.2672 185.656 98.0264 185.944 97.902 186.287C97.4447 187.531 96.7301 189.533 96.2373 191.217C95.4525 193.899 98.9966 194.518 102.479 194.249C105.962 193.981 106.291 192.45 105.81 190.235C105.502 188.853 105.111 187.443 104.867 186.566C104.793 186.321 104.649 186.104 104.453 185.94C104.257 185.776 104.018 185.673 103.765 185.643C103.481 185.61 103.194 185.673 102.949 185.822C102.704 185.97 102.516 186.196 102.413 186.464L102.021 187.502L101.027 187.632Z",
    fill: "#7CE4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.343 191.299L105.096 191.212L103.827 191.654L102.536 191.822L100.3 191.375C100.3 191.375 99.0718 189.468 99.16 191.589C99.2297 193.054 99.8493 193.895 100.227 194.281C100.977 194.315 101.729 194.3 102.478 194.238C103.044 194.206 103.604 194.111 104.148 193.955C104.525 193.419 105.134 192.432 105.343 191.299Z",
    fill: "#AAFAE7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M99.1241 191.407C98.837 190.601 98.3175 188.904 98.5342 187.625C98.7509 186.346 99.0363 185.295 99.6257 185.284C99.2672 185.222 98.8982 185.288 98.5832 185.471C98.2682 185.654 98.0274 185.942 97.9029 186.285C97.4454 187.53 96.7306 189.532 96.2376 191.216C95.5339 193.612 98.2948 194.359 101.385 194.3C100.715 194.189 99.863 193.484 99.1241 191.407Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.385 194.301L101.137 194.307L100.901 194.311L100.531 194.294L100.415 194.309L100.229 194.293C99.8533 193.921 99.2335 193.08 99.1637 191.614C99.1584 191.588 99.1594 191.56 99.1666 191.535C99.8922 193.508 100.729 194.202 101.385 194.301Z",
    fill: "#AAFAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.038 191.075L105.036 191.371C103.679 192.261 103.458 192.507 99.9636 191.409L99.9283 191.134L100.08 191.176C103.039 191.925 103.604 191.991 105.038 191.075Z",
    fill: "#2C4661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.688 192.226C100.145 192.098 100.4 191.577 100.258 191.063C100.115 190.549 99.6294 190.236 99.1723 190.364C98.7152 190.492 98.4601 191.012 98.6025 191.526C98.7449 192.04 99.2309 192.353 99.688 192.226Z",
    fill: "#738EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69 191.159C105.783 190.714 105.653 190.31 105.4 190.257C105.147 190.204 104.867 190.521 104.773 190.966C104.68 191.411 104.81 191.815 105.063 191.868C105.316 191.921 105.597 191.604 105.69 191.159Z",
    fill: "#738EFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M102.223 190.308C102.158 190.211 102.268 190.144 102.355 190.106C102.39 190.093 102.428 190.091 102.465 190.1C102.501 190.11 102.534 190.13 102.558 190.159L102.889 190.59C102.985 190.722 102.841 190.728 102.699 190.641C102.556 190.554 102.322 190.466 102.223 190.308Z",
    fill: "#284E7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M103.705 190.511L103.806 190.274C103.824 190.233 103.829 190.188 103.821 190.145C103.813 190.101 103.793 190.061 103.762 190.029L103.716 189.982C103.712 189.978 103.707 189.974 103.701 189.972C103.695 189.969 103.688 189.968 103.682 189.969C103.675 189.97 103.669 189.973 103.664 189.976C103.659 189.98 103.655 189.985 103.652 189.991C103.59 190.16 103.542 190.333 103.508 190.51C103.493 190.696 103.609 190.681 103.705 190.511Z",
    fill: "#284E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27 187.719L101.025 187.631L102.019 187.502L102.411 186.464C102.514 186.196 102.702 185.97 102.947 185.822C103.192 185.673 103.478 185.61 103.762 185.643L104.005 185.691C103.414 185.583 103.213 186.267 103.096 187.099C103.036 187.554 103.053 187.789 102.27 187.719Z",
    fill: "#61C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.593 187.53C104.595 187.212 104.387 186.954 104.128 186.952C103.87 186.951 103.658 187.207 103.656 187.525C103.654 187.842 103.862 188.101 104.121 188.102C104.379 188.104 104.59 187.847 104.593 187.53Z",
    fill: "#21354A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.212 187.34C100.244 187.024 100.06 186.747 99.8031 186.722C99.5458 186.696 99.312 186.932 99.2807 187.248C99.2495 187.564 99.4328 187.841 99.69 187.866C99.9473 187.891 100.181 187.656 100.212 187.34Z",
    fill: "#21354A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2411 199.24C98.7804 199.249 99.4679 199.186 100.081 199.158C100.07 198.913 100.091 198.666 100.145 198.426C100.239 198.022 100.383 197.632 100.574 197.264C100.083 197.223 99.4867 197.182 98.999 197.166C98.8984 194.743 97.628 193.434 96.9264 194.104C96.5939 194.421 96.3915 194.852 96.3591 195.31C96.3411 195.681 96.3787 196.282 96.3566 196.417C96.2952 196.859 95.984 196.992 96.3647 197.811C96.5615 198.22 96.1921 199.23 98.2411 199.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9229 185.377C100.423 185.694 100.549 186.468 100.589 186.779C100.628 187.09 100.7 187.647 100.718 187.789C100.736 187.932 100.782 187.979 101.256 188.193C101.73 188.408 101.532 188.197 101.316 187.949L101.026 187.631L100.896 186.62C100.86 186.345 100.75 186.084 100.579 185.865C100.408 185.647 100.181 185.478 99.9229 185.377Z",
    fill: "#D4FFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.323 187.151C104.502 187.22 104.543 187.636 104.364 187.475C104.186 187.314 104.076 187.065 104.323 187.151Z",
    fill: "#335A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9889 186.909C100.155 186.98 100.197 187.409 100.03 187.233C99.8635 187.057 99.7286 186.825 99.9889 186.909Z",
    fill: "#335A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.952 191.686C100.124 191.595 100.138 191.283 99.9833 190.99C99.8289 190.696 99.5646 190.532 99.393 190.623C99.2214 190.715 99.2074 191.026 99.3617 191.32C99.5161 191.613 99.7803 191.777 99.952 191.686Z",
    fill: "#B2A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.679 190.805C105.679 190.596 105.598 190.426 105.497 190.426C105.397 190.426 105.315 190.596 105.315 190.805C105.314 191.015 105.396 191.184 105.496 191.184C105.597 191.184 105.678 191.015 105.679 190.805Z",
    fill: "#B2A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.367 186.065C104.645 186.292 104.724 186.703 104.412 186.415C104.099 186.126 104.03 185.793 104.367 186.065Z",
    fill: "#D4FFDC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 181.931,
    width: 19.1478,
    height: 8.01064,
    rx: 2.03291,
    fill: "#2DDFB4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.606,
    y: 185.135,
    width: 19.1478,
    height: 4.80638,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 193.576C115.863 192.454 116.773 191.543 117.896 191.543H171.273C172.396 191.543 173.306 192.454 173.306 193.576V197.521C173.306 198.644 172.396 199.554 171.273 199.554H115.863V193.576Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 205,
    width: 17,
    height: 17
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 213.973,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.502,
    cy: 213.973,
    rx: 7.97824,
    ry: 8.01063,
    fill: "#FFB869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.408 216.589C98.3391 219.84 102.085 222.093 105.09 219.968C108.095 217.843 105.111 213.487 105.111 213.487C105.111 213.487 106.741 209.365 102.656 208.387C98.5719 207.41 97.5561 209.195 97.408 216.589Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.461 214.209C103.005 214.209 102.635 213.715 102.635 213.105C102.635 212.494 103.005 212 103.461 212C103.916 212 104.286 212.494 104.286 213.105C104.286 213.715 103.916 214.209 103.461 214.209Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.814 213.944C103.698 213.936 103.616 213.749 103.631 213.526C103.646 213.304 103.753 213.13 103.869 213.138C103.986 213.146 104.068 213.333 104.053 213.555C104.038 213.778 103.931 213.952 103.814 213.944Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.413 211.043C104.358 210.878 104.253 210.735 104.113 210.633C103.972 210.531 103.803 210.477 103.63 210.477C103.456 210.477 103.288 210.531 103.147 210.633C103.007 210.735 102.902 210.878 102.847 211.043H104.413Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.328 215.739C103.524 215.952 102.656 215.761 101.937 214.974C101.843 214.867 101.711 214.8 101.569 214.788C101.427 214.776 101.285 214.82 101.175 214.911C101.055 214.993 100.971 215.119 100.944 215.262C100.916 215.406 100.946 215.554 101.027 215.676C102.127 217.482 103.841 217.758 104.9 216.738C104.972 216.673 105.026 216.589 105.056 216.496C105.086 216.402 105.09 216.303 105.069 216.207C105.054 216.126 105.023 216.048 104.977 215.98C104.931 215.911 104.871 215.853 104.801 215.809C104.732 215.765 104.653 215.736 104.572 215.724C104.491 215.712 104.408 215.717 104.328 215.739Z",
    fill: "#590942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.714 215.824C103.922 215.826 104.129 215.797 104.328 215.739H104.519V216.27C104.519 216.27 104.201 216.504 103.016 216.377V216.079L100.942 215.378C100.943 215.29 100.964 215.204 101.005 215.127C101.045 215.049 101.104 214.982 101.175 214.932C101.175 214.926 101.177 214.921 101.181 214.917C101.185 214.913 101.19 214.911 101.196 214.911C101.283 214.851 101.387 214.821 101.492 214.826C101.514 214.804 101.556 214.826 101.577 214.826H101.767C101.789 214.847 101.81 214.847 101.81 214.868C101.81 214.889 101.852 214.868 101.852 214.889L101.937 214.953C102.062 215.097 102.204 215.226 102.36 215.336L102.656 215.527C102.794 215.612 102.944 215.677 103.101 215.718C103.298 215.786 103.506 215.822 103.714 215.824Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.175 214.911C101.175 214.905 101.177 214.9 101.181 214.896C101.185 214.892 101.19 214.889 101.196 214.889C101.283 214.83 101.387 214.8 101.492 214.804C101.514 214.783 101.556 214.804 101.577 214.804H101.767C101.789 214.826 101.81 214.826 101.81 214.847C101.81 214.868 101.852 214.847 101.852 214.868L101.937 214.932C102.003 215.02 102.082 215.099 102.17 215.166L101.577 215.527L100.942 215.314C100.949 215.234 100.974 215.156 101.014 215.087C101.054 215.017 101.109 214.957 101.175 214.911Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2757 209.875C99.0375 208.175 100.371 207.835 102.656 208.387C103.117 208.491 103.559 208.663 103.968 208.897C104.095 209.577 103.058 209.79 101.133 209.174C101.767 210.321 100.455 212.361 98.2757 209.875Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.942 208.324L101.048 206.921C101.057 206.793 101.039 206.665 100.995 206.544C100.95 206.424 100.88 206.315 100.79 206.224C100.7 206.133 100.591 206.063 100.471 206.018C100.351 205.974 100.223 205.955 100.096 205.965C99.952 205.973 99.8125 206.016 99.6891 206.09C99.5657 206.165 99.4621 206.268 99.3872 206.391C99.3123 206.514 99.2683 206.654 99.259 206.798C99.2497 206.942 99.2753 207.087 99.3338 207.219L99.9687 208.664L100.942 208.324Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4399 215.824L96.0747 216.058L97.408 215.187V216.271L98.5084 217.142C98.7396 217.333 98.93 217.568 99.0682 217.835C99.2064 218.101 99.2895 218.393 99.3126 218.693L99.355 219.564C100.963 220.903 103.164 221.328 105.09 219.968C105.403 219.758 105.682 219.5 105.915 219.203L106.571 219.437C106.571 219.437 105.238 225.068 103.016 226.088C100.794 227.107 99.2491 226.088 99.2491 226.088C96.9212 218.14 97.5985 216.653 91.8422 218.948L91.5671 217.333L95.4399 215.824Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.053 213.296L95.8631 209.365L95.4822 209.854L98.7201 215.909L100.053 213.296Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5296 212.403L96.8789 211.235L98.1487 213.53L97.9159 212.637L98.5296 212.403Z",
    fill: "#3366E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.863,
    y: 205.963,
    width: 19.1478,
    height: 8.01063,
    rx: 2.03291,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.606,
    y: 209.167,
    width: 19.1478,
    height: 4.80638,
    rx: 2.03291,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 217.608C115.863 216.485 116.773 215.575 117.896 215.575H190.421C191.544 215.575 192.454 216.485 192.454 217.608V221.553C192.454 222.676 191.544 223.586 190.421 223.586H115.863V217.608Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.863 223.586H179.689V229.564C179.689 230.686 178.779 231.597 177.656 231.597H117.896C116.773 231.597 115.863 230.686 115.863 229.564V223.586Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7253 22.9801C19.7253 20.7346 21.5456 18.9143 23.7911 18.9143H82.3545V231.196H23.7911C21.5456 231.196 19.7253 229.376 19.7253 227.13V22.9801Z",
    fill: "#1C1B29"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5211 46.551C28.3631 46.551 28.2434 46.4083 28.2709 46.2526L28.5014 44.9489H27.208C27.0502 44.9489 26.9305 44.8066 26.9576 44.6511L27.0087 44.3583C27.0299 44.2366 27.1355 44.1478 27.259 44.1478H28.641L29.0638 41.7446H27.7704C27.6126 41.7446 27.493 41.6023 27.5201 41.4469L27.5711 41.154C27.5923 41.0324 27.698 40.9436 27.8215 40.9436H29.2035L29.4496 39.5513C29.471 39.4299 29.5765 39.3414 29.6998 39.3414H29.9815C30.1396 39.3414 30.2593 39.4842 30.2318 39.6398L30.0013 40.9436H32.3948L32.6409 39.5513C32.6623 39.4299 32.7678 39.3414 32.8911 39.3414H33.1728C33.3309 39.3414 33.4506 39.4842 33.4231 39.6398L33.1926 40.9436H34.486C34.6438 40.9436 34.7634 41.0859 34.7363 41.2413L34.6853 41.5341C34.6641 41.6558 34.5585 41.7446 34.435 41.7446H33.053L32.6301 44.1478H33.9235C34.0813 44.1478 34.201 44.2901 34.1739 44.4456L34.1228 44.7384C34.1016 44.8601 33.996 44.9489 33.8725 44.9489H32.4905L32.2444 46.3411C32.2229 46.4625 32.1174 46.551 31.9941 46.551H31.7124C31.5544 46.551 31.4347 46.4083 31.4622 46.2526L31.6927 44.9489H29.2992L29.0531 46.3411C29.0316 46.4625 28.9261 46.551 28.8028 46.551H28.5211ZM29.8619 41.7446L29.439 44.1478H31.8325L32.2553 41.7446H29.8619Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6709,
    y: 38.1399,
    width: 36.301,
    height: 9.61276,
    rx: 2.03291,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5211 65.7765C28.3631 65.7765 28.2434 65.6337 28.2709 65.4781L28.5014 64.1743H27.208C27.0502 64.1743 26.9305 64.032 26.9576 63.8766L27.0087 63.5838C27.0299 63.4621 27.1355 63.3733 27.259 63.3733H28.641L29.0638 60.9701H27.7704C27.6126 60.9701 27.493 60.8278 27.5201 60.6723L27.5711 60.3795C27.5923 60.2578 27.698 60.169 27.8215 60.169H29.2035L29.4496 58.7768C29.471 58.6554 29.5765 58.5669 29.6998 58.5669H29.9815C30.1396 58.5669 30.2593 58.7096 30.2318 58.8652L30.0013 60.169H32.3948L32.6409 58.7768C32.6623 58.6554 32.7678 58.5669 32.8911 58.5669H33.1728C33.3309 58.5669 33.4506 58.7096 33.4231 58.8652L33.1926 60.169H34.486C34.6438 60.169 34.7634 60.3113 34.7363 60.4668L34.6853 60.7596C34.6641 60.8813 34.5585 60.9701 34.435 60.9701H33.053L32.6301 63.3733H33.9235C34.0813 63.3733 34.201 63.5156 34.1739 63.671L34.1228 63.9639C34.1016 64.0855 33.996 64.1743 33.8725 64.1743H32.4905L32.2444 65.5666C32.2229 65.688 32.1174 65.7765 31.9941 65.7765H31.7124C31.5544 65.7765 31.4347 65.6337 31.4622 65.4781L31.6927 64.1743H29.2992L29.0531 65.5666C29.0316 65.688 28.9261 65.7765 28.8028 65.7765H28.5211ZM29.8619 60.9701L29.439 63.3732H31.8325L32.2553 60.9701H29.8619Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6709,
    y: 57.3654,
    width: 33.1097,
    height: 9.61276,
    rx: 2.03291,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5211 85.0019C28.3631 85.0019 28.2434 84.8592 28.2709 84.7036L28.5014 83.3998H27.208C27.0502 83.3998 26.9305 83.2575 26.9576 83.1021L27.0087 82.8092C27.0299 82.6875 27.1355 82.5987 27.259 82.5987H28.641L29.0638 80.1955H27.7704C27.6126 80.1955 27.493 80.0532 27.5201 79.8978L27.5711 79.605C27.5923 79.4833 27.698 79.3945 27.8215 79.3945H29.2035L29.4496 78.0022C29.471 77.8808 29.5765 77.7924 29.6998 77.7924H29.9815C30.1396 77.7924 30.2593 77.9351 30.2318 78.0907L30.0013 79.3945H32.3948L32.6409 78.0022C32.6623 77.8808 32.7678 77.7924 32.8911 77.7924H33.1728C33.3309 77.7924 33.4506 77.9351 33.4231 78.0907L33.1926 79.3945H34.486C34.6438 79.3945 34.7634 79.5368 34.7363 79.6922L34.6853 79.9851C34.6641 80.1067 34.5585 80.1955 34.435 80.1955H33.053L32.6301 82.5987H33.9235C34.0813 82.5987 34.201 82.741 34.1739 82.8965L34.1228 83.1893C34.1016 83.311 33.996 83.3998 33.8725 83.3998H32.4905L32.2444 84.7921C32.2229 84.9134 32.1174 85.0019 31.9941 85.0019H31.7124C31.5544 85.0019 31.4347 84.8592 31.4622 84.7036L31.6927 83.3998H29.2992L29.0531 84.7921C29.0316 84.9134 28.9261 85.0019 28.8028 85.0019H28.5211ZM29.8619 80.1955L29.439 82.5987H31.8325L32.2553 80.1955H29.8619Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6709,
    y: 76.5908,
    width: 36.301,
    height: 9.61276,
    rx: 2.03291,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5211 104.228C28.3631 104.228 28.2434 104.085 28.2709 103.929L28.5014 102.625H27.208C27.0502 102.625 26.9305 102.483 26.9576 102.328L27.0087 102.035C27.0299 101.913 27.1355 101.824 27.259 101.824H28.641L29.0638 99.4211H27.7704C27.6126 99.4211 27.493 99.2788 27.5201 99.1234L27.5711 98.8306C27.5923 98.7089 27.698 98.6201 27.8215 98.6201H29.2035L29.4496 97.2278C29.471 97.1064 29.5765 97.0179 29.6998 97.0179H29.9815C30.1396 97.0179 30.2593 97.1607 30.2318 97.3163L30.0013 98.6201H32.3948L32.6409 97.2278C32.6623 97.1064 32.7678 97.0179 32.8911 97.0179H33.1728C33.3309 97.0179 33.4506 97.1607 33.4231 97.3163L33.1926 98.6201H34.486C34.6438 98.6201 34.7634 98.7624 34.7363 98.9178L34.6853 99.2107C34.6641 99.3323 34.5585 99.4211 34.435 99.4211H33.053L32.6301 101.824H33.9235C34.0813 101.824 34.201 101.967 34.1739 102.122L34.1228 102.415C34.1016 102.537 33.996 102.625 33.8725 102.625H32.4905L32.2444 104.018C32.2229 104.139 32.1174 104.228 31.9941 104.228H31.7124C31.5544 104.228 31.4347 104.085 31.4622 103.929L31.6927 102.625H29.2992L29.0531 104.018C29.0316 104.139 28.9261 104.228 28.8028 104.228H28.5211ZM29.8619 99.4211L29.439 101.824H31.8325L32.2553 99.4211H29.8619Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6709,
    y: 95.8164,
    width: 26.7271,
    height: 9.61276,
    rx: 2.03291,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5211 123.453C28.3631 123.453 28.2434 123.31 28.2709 123.155L28.5014 121.851H27.208C27.0502 121.851 26.9305 121.709 26.9576 121.553L27.0087 121.26C27.0299 121.139 27.1355 121.05 27.259 121.05H28.641L29.0638 118.647H27.7704C27.6126 118.647 27.493 118.504 27.5201 118.349L27.5711 118.056C27.5923 117.934 27.698 117.846 27.8215 117.846H29.2035L29.4496 116.453C29.471 116.332 29.5765 116.244 29.6998 116.244H29.9815C30.1396 116.244 30.2593 116.386 30.2318 116.542L30.0013 117.846H32.3948L32.6409 116.453C32.6623 116.332 32.7678 116.244 32.8911 116.244H33.1728C33.3309 116.244 33.4506 116.386 33.4231 116.542L33.1926 117.846H34.486C34.6438 117.846 34.7634 117.988 34.7363 118.143L34.6853 118.436C34.6641 118.558 34.5585 118.647 34.435 118.647H33.053L32.6301 121.05H33.9235C34.0813 121.05 34.201 121.192 34.1739 121.348L34.1228 121.64C34.1016 121.762 33.996 121.851 33.8725 121.851H32.4905L32.2444 123.243C32.2229 123.365 32.1174 123.453 31.9941 123.453H31.7124C31.5544 123.453 31.4347 123.31 31.4622 123.155L31.6927 121.851H29.2992L29.0531 123.243C29.0316 123.365 28.9261 123.453 28.8028 123.453H28.5211ZM29.8619 118.647L29.439 121.05H31.8325L32.2553 118.647H29.8619Z",
    fill: "#B9BBBE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.6709,
    y: 115.042,
    width: 36.301,
    height: 9.61276,
    rx: 2.03291,
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9372 43.3467C95.7792 43.3467 95.6595 43.2039 95.687 43.0483L95.9175 41.7445H94.6241C94.4663 41.7445 94.3466 41.6022 94.3737 41.4468L94.4248 41.1539C94.446 41.0323 94.5516 40.9435 94.6751 40.9435H96.0571L96.4799 38.5403H95.1865C95.0287 38.5403 94.9091 38.398 94.9362 38.2425L94.9872 37.9497C95.0084 37.828 95.1141 37.7392 95.2376 37.7392H96.6196L96.8657 36.347C96.8871 36.2256 96.9926 36.1371 97.1159 36.1371H97.3976C97.5557 36.1371 97.6754 36.2798 97.6479 36.4354L97.4174 37.7392H99.8108L100.057 36.347C100.078 36.2256 100.184 36.1371 100.307 36.1371H100.589C100.747 36.1371 100.867 36.2798 100.839 36.4354L100.609 37.7392H101.902C102.06 37.7392 102.18 37.8815 102.152 38.037L102.101 38.3298C102.08 38.4515 101.975 38.5403 101.851 38.5403H100.469L100.046 40.9435H101.34C101.497 40.9435 101.617 41.0858 101.59 41.2412L101.539 41.534C101.518 41.6557 101.412 41.7445 101.289 41.7445H99.9066L99.6605 43.1368C99.639 43.2582 99.5335 43.3467 99.4102 43.3467H99.1285C98.9705 43.3467 98.8508 43.2039 98.8783 43.0483L99.1088 41.7445H96.7153L96.4692 43.1368C96.4477 43.2582 96.3422 43.3467 96.2189 43.3467H95.9372ZM97.2779 38.5402L96.8551 40.9434H99.2486L99.6714 38.5402H97.2779Z",
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76 38.6765V41.4562C106.76 42.1852 107.135 42.6257 107.861 42.6257C108.371 42.6257 108.786 42.3454 109.145 42.0009L109.233 42.5456H110.047V38.6765H109.09V41.288C108.81 41.5764 108.507 41.7686 108.212 41.7686C107.861 41.7686 107.717 41.5443 107.717 41.2079V38.6765H106.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.591 40.559C113.591 41.4081 113.216 41.8167 112.721 41.8167C112.394 41.8167 112.211 41.7606 111.979 41.6484V39.9902C112.235 39.6618 112.506 39.4455 112.849 39.4455C113.28 39.4455 113.591 39.814 113.591 40.559ZM114.556 40.5029C114.556 39.2052 113.91 38.5964 113.104 38.5964C112.57 38.5964 112.195 38.8928 111.924 39.2052L111.836 38.6765H111.022V44.0356L111.979 43.8914V42.4335C112.211 42.5216 112.506 42.5857 112.873 42.5857C113.759 42.5857 114.556 41.9448 114.556 40.5029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.112 40.6631C116.112 39.814 116.471 39.4055 116.974 39.4055C117.301 39.4055 117.485 39.4615 117.724 39.5737V41.2319C117.469 41.5603 117.197 41.7686 116.846 41.7686C116.423 41.7686 116.112 41.4161 116.112 40.6631ZM115.147 40.7192C115.147 42.0249 115.793 42.6257 116.599 42.6257C117.134 42.6257 117.509 42.3374 117.78 42.0089L117.86 42.5456H118.681V36.762L117.724 36.9142V38.7806C117.493 38.7005 117.197 38.6365 116.83 38.6365C115.937 38.6365 115.147 39.2773 115.147 40.7192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.761 41.4802C121.498 41.7366 121.187 41.8968 120.859 41.8968C120.564 41.8968 120.389 41.7286 120.389 41.4482C120.389 41.0797 120.652 40.7513 121.761 40.6151V41.4802ZM122.718 42.5456V39.8941C122.718 38.9649 122.224 38.5964 121.226 38.5964C120.612 38.5964 120.141 38.7326 119.695 38.9088L119.814 39.6778C120.229 39.4936 120.652 39.3654 121.099 39.3654C121.522 39.3654 121.761 39.5256 121.761 39.9422V40.0543C120.205 40.2065 119.439 40.6151 119.439 41.5523C119.439 42.2252 119.878 42.6257 120.532 42.6257C121.107 42.6257 121.506 42.3694 121.817 42.041L121.897 42.5456H122.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.742 42.5456L125.622 41.7366C125.534 41.7606 125.43 41.7686 125.319 41.7686C124.952 41.7686 124.816 41.6004 124.816 41.288V39.4615H125.718L125.598 38.6765H124.816V37.3067L123.867 37.4509V38.6765H123.324V39.4615H123.867V41.4482C123.867 42.3294 124.377 42.6097 125.135 42.6097C125.415 42.6097 125.59 42.5777 125.742 42.5456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.957 39.2613C128.42 39.2613 128.659 39.5977 128.723 40.1985H127.183C127.255 39.5737 127.574 39.2613 127.957 39.2613ZM129.649 42.1531L129.537 41.4001C129.114 41.6965 128.707 41.8808 128.213 41.8808C127.622 41.8808 127.215 41.5523 127.175 40.7993H129.649C129.649 40.7432 129.657 40.6471 129.657 40.567C129.657 39.4696 129.138 38.5964 127.981 38.5964C126.976 38.5964 126.226 39.3574 126.226 40.6151C126.226 42.0089 127.032 42.6257 128.109 42.6257C128.731 42.6257 129.234 42.4415 129.649 42.1531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.286 41.4081C133.286 40.6792 132.895 40.4068 131.898 40.1505C131.324 39.9983 131.18 39.8781 131.18 39.6698C131.18 39.4615 131.356 39.3174 131.715 39.3174C132.098 39.3174 132.552 39.4535 132.935 39.6698L133.063 38.8688C132.68 38.7005 132.217 38.5964 131.715 38.5964C130.821 38.5964 130.294 39.069 130.294 39.7419C130.294 40.4469 130.685 40.7192 131.619 40.9595C132.233 41.1117 132.401 41.2239 132.401 41.4962C132.401 41.7526 132.177 41.9048 131.762 41.9048C131.284 41.9048 130.773 41.7205 130.358 41.4482L130.231 42.2492C130.598 42.4495 131.172 42.6257 131.731 42.6257C132.744 42.6257 133.286 42.1691 133.286 41.4081Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.365 265.424V323.982H172.635V265.424H203C201.753 265.413 200.516 265.652 199.362 266.127C198.208 266.601 197.159 267.301 196.278 268.187C195.396 269.072 194.698 270.125 194.226 271.284C193.753 272.443 193.515 273.684 193.526 274.937V305.112C193.518 306.995 194.067 308.836 195.103 310.405C196.139 311.974 197.615 313.199 199.344 313.925C201.073 314.651 202.978 314.846 204.818 314.485C206.658 314.124 208.349 313.223 209.679 311.896C211.456 310.087 212.459 307.653 212.474 305.112V274.937C212.474 272.414 211.476 269.994 209.699 268.21C207.923 266.426 205.513 265.424 203 265.424H233.365Z",
    fill: "#11111A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.017 320.629H119.983C110.141 320.578 100.374 322.349 91.1714 325.854V331H314.751V325.854C305.577 322.343 295.834 320.572 286.017 320.629Z",
    fill: "#2C2C40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.751 325.854H91.1714V331.078H314.751V325.854Z",
    fill: "#11111A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 99.2316,
    y1: 127.453,
    x2: 99.9509,
    y2: 135.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 92.2591,
    y1: 135.963,
    x2: 107.214,
    y2: 128.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D67569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 95.9054,
    y1: 191.43,
    x2: 98.528,
    y2: 190.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54B9C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 331,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301.976,
    height: 212.282,
    fill: "white",
    transform: "translate(19.7253 18.9143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01063,
    fill: "white",
    transform: "translate(115.863 55.3627)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(119.054 71.3839)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01063,
    fill: "white",
    transform: "translate(115.863 93.8137)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01063,
    fill: "white",
    transform: "translate(115.863 125.856)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01063,
    fill: "white",
    transform: "translate(115.863 149.888)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01064,
    fill: "white",
    transform: "translate(115.863 181.931)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.8912,
    height: 8.01063,
    fill: "white",
    transform: "translate(115.863 205.963)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(26.1079 38.1399)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(26.1079 57.3654)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(26.1079 76.5908)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(26.1079 95.8164)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57388,
    height: 9.61276,
    fill: "white",
    transform: "translate(26.1079 115.042)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelloImg1649933868113);
export default __webpack_public_path__ + "static/media/HelloIMG1649933868113.646e3df64978d10e84e893cdf073a49b.svg";
export { ForwardRef as ReactComponent };